import React__default from 'react';
import './Empty.scss';

const Empty = (props) => {
    return (React__default.createElement("div", { "data-rev-component": 'empty', className: props.className, "aria-label": props.ariaLabel },
        props.icon && React__default.createElement("div", { className: 'empty-icon--rev' }, props.icon),
        React__default.createElement("div", { className: 'empty-text-body--rev' },
            props.title && React__default.createElement("div", { className: 'empty-title--rev' }, props.title),
            props.description && (React__default.createElement("div", { className: 'empty-description--rev' }, props.description))),
        props.content && React__default.createElement("div", { className: 'empty-content--rev' }, props.content)));
};

export { Empty };
//# sourceMappingURL=Empty.js.map
